import React from 'react';
import useReveal from '../hooks/use-reveal';

const NotBroken = () => {
  const r = useReveal();
  return (
    <div
      data-testid="not-broken-section"
      style={{
        background: 'var(--yup-surface)',
        padding: '80px 24px',
        textAlign: 'center',
      }}
    >
      <div
        ref={r.ref}
        className={`reveal ${r.visible ? 'visible' : ''}`}
        style={{ maxWidth: '640px', margin: '0 auto' }}
      >
        <h2
          className="font-serif"
          style={{
            fontSize: 'clamp(28px, 5vw, 50px)',
            fontWeight: 300,
            lineHeight: 1.2,
            marginBottom: '24px',
            letterSpacing: '-0.5px',
          }}
        >
          You don't have to be<br />
          <em style={{ fontStyle: 'italic', color: 'var(--yup-accent)' }}>broken</em> to do this.
        </h2>
        <p style={{ color: 'var(--yup-muted)', fontSize: '16px', lineHeight: 1.8, marginBottom: '16px' }}>
          You just have to be someone who suspects there's a more honest version of
          yourself available. Someone who's tired of saying <em>yup</em> when the real
          answer is more complicated than that.
        </p>
        <p style={{ color: 'var(--yup-muted)', fontSize: '16px', lineHeight: 1.8, marginBottom: '16px' }}>
          This isn't about performing healing online. It isn't about oversharing. It's
          about finding out what happens when you let your actual voice out — even a
          little — and seeing what shifts.
        </p>
        <p style={{ color: 'var(--yup-muted)', fontSize: '16px', lineHeight: 1.8, marginBottom: '16px' }}>
          <strong style={{ color: 'var(--yup-ink)', fontWeight: 500 }}>
            Walk it privately if that's what you need. Share with #unmaskyourvoice when something feels true enough to say out loud. Every voice helps the next person find theirs.
          </strong>
        </p>
      </div>
    </div>
  );
};

export default NotBroken;
